import CloseIcon from '@mui/icons-material/Close';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import { applyUpdate } from '../../../helpers/version';
import useVersionCheck from '../../../hooks/useVersionCheck';

const UpdateNotification = () => {
  const { updateInfo, dismiss } = useVersionCheck()

  if (!updateInfo) return null

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
      <Alert
        variant="filled"
        icon={false}
        sx={{
          width: '100%',
          alignItems: 'center',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
        action={
          <>
            <Button
              size="small"
              aria-label="apply the update"
              onClick={() => applyUpdate()}
              sx={{
                bgcolor: 'primary.contrastText',
                color: 'primary.main',
                border: 'none',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: 'primary.contrastText',
                  opacity: 0.85,
                  boxShadow: 'none',
                },
              }}
            >
              Reload
            </Button>
            <IconButton
              aria-label="dismiss"
              size="small"
              onClick={dismiss}
              sx={{ color: 'inherit', ml: 1 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        A new version (v{updateInfo?.version}) is available.
      </Alert>
    </Snackbar>
  )
}

export default UpdateNotification
